import { createSingleInterpolatedTranslationKey, TranslatableText, useTranslate } from '@dreryk/react-common';

import { appointmentsTranslationKeys } from '../../../translations';
import { VisitEncounterMode } from '../AppointmentsFilterPanel/fields/VisitEncounterModeField/VisitEncounterModeField.types';
import { getVisitEncounterModeFilterCount } from '../AppointmentsFilterPanel/fields/VisitEncounterModeField/VisitEncounterModeField.utils';

const FILTER_SEPARATOR = ', ';

export const useVisitEncounterModeFilterLabel = (visitEncounterModes: VisitEncounterMode[]): TranslatableText => {
   const translate = useTranslate();

   if (visitEncounterModes.length === getVisitEncounterModeFilterCount()) {
      return createSingleInterpolatedTranslationKey(
         appointmentsTranslationKeys.visitEncounterModeFilter.filterLabel,
         'encounterModes',
         translate(appointmentsTranslationKeys.visitEncounterModeFilter.filterLabelAll)
      );
   }

   return createSingleInterpolatedTranslationKey(
      appointmentsTranslationKeys.visitEncounterModeFilter.filterLabel,
      'encounterModes',
      visitEncounterModes
         .map((encounterMode) => translate(appointmentsTranslationKeys.visitEncounterModeMap[encounterMode]))
         .join(FILTER_SEPARATOR)
   );
};
